import WrapperTable from './WrapperTable'

export default WrapperTable